import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  failure: {
    id: 'learning.loading.failure',
    defaultMessage: 'There was an error loading this course.',
    description: 'Can be because internet connection or any technical other reason',
  },
  loading: {
    id: 'learning.loading',
    defaultMessage: 'Loading course page…',
    description: 'When content of the course is still loading...etc',
  },
  studioText: {
    id: 'menu.studio.link.text',
    defaultMessage: 'Studio',
    description: 'Studio text shown in app menu',
  },
  LibraryText: {
    id: 'menu.library.link.text',
    defaultMessage: 'Library',
    description: 'Library text shown in app menu',
  },
  assetManagementText: {
    id: 'menu.asset.management.link.text',
    defaultMessage: 'Assets Management',
    description: 'Assets managment text shown in app menu',
  },
  unreadNotifications: {
    id: 'notifications.unread.text',
    defaultMessage: 'Unread Notifications',
    description: 'Unread Notifications text',
  },
  viewAllnotificationsText: {
    id: 'notifications.view.all.text',
    defaultMessage: 'View All',
    description: 'Notifications view all button text',
  },
  noNotificationsText: {
    id: 'notifications.no.results',
    defaultMessage: 'No Results Found',
    description: 'No notifications results found text',
  },
});

export default messages;
